export const OFFER_SUCCESS_REDIRECT_URL =
  "https://www.optroodtbuitenleven.nl/bedankt/";

export const INNOVEET_CONFIGURATOR_MESSAGE_SOURCE = "innoveet-configurator";
export const OFFER_SUBMIT_SUCCESS_MESSAGE_TYPE = "offer-submit-success";
export const REDIRECT_MESSAGE_ACTION = "redirect";

export interface OfferSubmitSuccessMessage {
  source: typeof INNOVEET_CONFIGURATOR_MESSAGE_SOURCE;
  type: typeof OFFER_SUBMIT_SUCCESS_MESSAGE_TYPE;
  action: typeof REDIRECT_MESSAGE_ACTION;
  url: typeof OFFER_SUCCESS_REDIRECT_URL;
}

type RedirectWindow = {
  location: Pick<Location, "assign" | "search">;
  parent: Pick<Window, "postMessage">;
  self: unknown;
  top: unknown;
};

type RedirectDocument = Pick<Document, "referrer">;
type WindowFrameContext = Pick<RedirectWindow, "self" | "top">;

const allowedOriginProtocols = new Set(["http:", "https:"]);

export const normalizeOrigin = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  try {
    const url = new URL(value);

    if (!allowedOriginProtocols.has(url.protocol)) {
      return null;
    }

    return url.origin;
  } catch {
    return null;
  }
};

export const resolveAllowedParentOrigin = (
  search = window.location.search,
  referrer = document.referrer
): string | null => {
  const parentOrigin = new URLSearchParams(search).get("parentOrigin");

  return normalizeOrigin(parentOrigin) ?? normalizeOrigin(referrer);
};

export const createOfferSubmitSuccessMessage = (): OfferSubmitSuccessMessage => ({
  source: INNOVEET_CONFIGURATOR_MESSAGE_SOURCE,
  type: OFFER_SUBMIT_SUCCESS_MESSAGE_TYPE,
  action: REDIRECT_MESSAGE_ACTION,
  url: OFFER_SUCCESS_REDIRECT_URL,
});

export const isEmbeddedWindow = (
  currentWindow: WindowFrameContext = window
): boolean => {
  try {
    return currentWindow.self !== currentWindow.top;
  } catch {
    return true;
  }
};

export const redirectAfterOfferSubmitSuccess = (
  currentWindow: RedirectWindow = window,
  currentDocument: RedirectDocument = document
): void => {
  if (isEmbeddedWindow(currentWindow)) {
    const allowedParentOrigin = resolveAllowedParentOrigin(
      currentWindow.location.search,
      currentDocument.referrer
    );

    if (!allowedParentOrigin) {
      console.error(
        "Innoveet configurator: parent origin is missing or invalid; redirect message was not sent."
      );
      return;
    }

    currentWindow.parent.postMessage(
      createOfferSubmitSuccessMessage(),
      allowedParentOrigin
    );
    return;
  }

  currentWindow.location.assign(OFFER_SUCCESS_REDIRECT_URL);
};
